import PropTypes from 'prop-types';

function NoMatch(props) {
    const message = props.message
        || (props.location.state && props.location.state.message)
        || 'Page not found';
    return (
        <h2>
            {message}
        </h2>
    );
}

NoMatch.propTypes = {
    message: PropTypes.string,
    location: PropTypes.shape(
        { state: PropTypes.shape({ message: PropTypes.string }) },
    ),
};

NoMatch.defaultProps = {
    message: '',
    location: {},
};

export default NoMatch;
